// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list","962":"home"}[chunkId] || chunkId) + "-" + {"137":"8f1952ff70d3f8ea3634","702":"4d5c083e5b375b1b7479","715":"6ebe6ec7d2dabcdfefc1","962":"16b1e04535593de6aeee"}[chunkId] + ".css";
};